import { Component, EventEmitter, inject, Input, Output } from '@angular/core';

import { MakersiteService } from '@services/makersite.service';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { MatOptionModule } from '@angular/material/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AvatarComponent } from '@mds/ui';

@Component({
  selector: 'app-invite-team',
  standalone: true,
  imports: [MatAutocompleteModule, MatInputModule, MatOptionModule, MatProgressBarModule, ReactiveFormsModule, FormsModule, AvatarComponent],
  templateUrl: './invite-team.component.html',
  styleUrls: [
    '../team-common.scss',
    './invite-team.component.scss']
})
export class InviteTeamComponent {
  loading = false;
  optionsList: any;
  userName: string;
  @Input() data: { inviteEmail: string; inviteRid: string; fieldName: string; };
  @Input() label = '';
  @Output() invited: any = new EventEmitter();
  private makersiteService = inject(MakersiteService);

  @Input() set reset(value: object) {
    this.userName = '';
    this.optionsList = [];
  }

  fetchData(event: string) {
    this.optionsList = [];
    this.loading = true;
    this.makersiteService.getTeamAndUser(event)
      .subscribe({
        next: (res) => {
          this.loading = false;
          if (Array.isArray(res)) {
            if (res.length === 0) {
              this.validateEmail(event);
            }
            this.optionsList = res;
          } else if (res) {
            this.optionsList = res;
          }
        },
        complete: () => {
          this.loading = false;
        }
      });
  }

  validateEmail(email: string) {
    const reg = /^[_a-z0-9]+(\.[_a-z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/;
    if (reg.test(email)) {
      this.data.inviteEmail = email;
      this.data.inviteRid = '';
    }
  }

  updateSelection(option: { value: { name: string, rid: string, firstname: string, lastname: string, type: string } }) {
    this.data.inviteEmail = option.value.name;
    this.data.inviteRid = option.value.rid;
    if (option.value.type === 'user') {
      this.userName = `${option.value.firstname} ${option.value.lastname}`;
    } else {
      this.userName = option.value.name;
    }
    this.invited.emit(option);
  }
}
